export default "__VITE_ASSET__DFBzvvcV__"